<template>
  <div>
    <div v-if="currentSession && !loading" class="card card-default">
      <div class="card-header">
        <h4>Connectivity Status</h4>
        <span
          v-if="connectivityService.currentlyCapped"
          class="badge text-white badge-capped"
          >Capped</span
        >
      </div>
      <div class="card-body">
        <div class="form-group row mb-md-0">
          <label class="col-md-6 mb-md-0">Status:</label>
          <div class="col-md-6">
            <strong class="text-uppercase" :class="connected">{{
              connected
            }}</strong>
          </div>
        </div>
        <div class="form-group row mb-md-0">
          <label class="col-md-6 mb-md-0">Last Updated:</label>
          <div class="col-md-6">
            <strong>{{dateTimeFormat(currentSession.lastUpdate)}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    connectivityService: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      loadedSession: null,
    };
  },
  computed: {
    requestKey() {
      return JSON.stringify({
        enabled: this.enabled,
        url: this.url,
        queryParams: this.queryParams,
      });
    },
    currentSession() {
      return this.session || this.loadedSession;
    },
    connected() {
      return this.dateFormat(this.currentSession.stopTime) ==
        "1970-01-01"
        ? "connected"
        : "disconnected";
    },
  },
  watch: {
    requestKey: {
      immediate: true,
      handler() {
        this.fetchSession();
      },
    },
  },
  methods: {
    fetchSession() {
      if (this.session || !this.url || !this.enabled) {
        this.loadedSession = null;
        this.loading = false;
        return;
      }

      this.loading = true;
      const params = new URLSearchParams({
        ...this.queryParams,
        order: '-startTime',
        page: 1,
        pageSize: 1,
      });

      this.$http.get(`${this.url}/paged?${params.toString()}`).then(
        (response) => {
          const results = response.data.results || [];
          this.loadedSession = results.length > 0 ? results[0] : null;
          this.loading = false;
        },
        (error) => {
          this.loadedSession = null;
          this.loading = false;
          this.showError('Error fetching connectivity status', error);
          console.error(error);
        }
      );
    },
  },
};
</script>

<style>
.connected {
  color: green;
}

.disconnected {
  color: orange;
}

.badge-capped {
  background-color: orange !important;
  font-size: 17;
}
</style>
